<template>
  <!-- 客服中心来电弹屏 -->
  <div class="show-info-container" ref="target">
    <div class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="header-left">
            <div class="box-title">来电信息&nbsp;&nbsp;</div>
            <div class="box-title"
                 style="color :black;">（手机号：{{this.callerid}} | 来电归属地：{{this.phonePlace}} )</div>
          </div>
          <div class="header-right"
               @click="closePage">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="box-header bg-mg"></div>
        <div class="box-body box-border-body">
          <div class="modal-body">
            <div class="item box-primary">
              <div class="staff-top">
                <div class="staff-title">员工</div>
              </div>
              <div class="staff-bottom">
                <div class="inp">
                  <label class="label">员工姓名</label>
                  <el-input v-model="staff.name"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">员工手机</label>
                  <el-input v-model="staff.callerid"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">所属部门</label>
                  <el-input v-model="staff.departmentName"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">所属岗位</label>
                  <el-input v-model="staff.postName"
                            disabled></el-input>
                </div>
              </div>
            </div>
            <div class="plate-product">
              <div class="select-plate-product">
                <label class="label">车牌号及产品</label>
                <el-select class="select"
                           v-model="selectValue"
                           placeholder="请选择"
                           @change="select">
                  <el-option v-for="item in options"
                             :key="item.id"
                             :label="item.carNo+'-'+item.productName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="item box-primary">
              <div class="member-top">
                <div class="member-title">会员</div>
              </div>
              <div class="member-bottom">
                <div class="inp">
                  <label class="label">使用人姓名</label>
                  <el-input v-model="data.userName"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">使用人手机</label>
                  <el-input v-model="data.userPhone"
                            disabled></el-input>
                </div>
              </div>
            </div>
            <div class="item box-primary">
              <div class="staff-top">
                <div class="staff-title">车辆</div>
              </div>
              <div class="staff-bottom">
                <div class="inp">
                  <label class="label">车牌号</label>
                  <el-input v-model="data.carNo"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">车型品牌</label>
                  <el-input v-model="data.carTypeBrand"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">购车时间</label>
                  <el-input v-model="data.buyCarTime"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">保质期</label>
                  <el-input v-model="data.shelfLife"
                            disabled></el-input>
                </div>
              </div>
            </div>
            <div class="item box-primary">
              <div class="staff-top">
                <div class="staff-title">产品信息</div>
              </div>
              <div class="staff-bottom">
                <div class="inp">
                  <label class="label">产品名称</label>
                  <el-input v-model="data.productName"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">产品期限</label>
                  <el-input v-model="data.productTimeLimit"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">购买日期</label>
                  <el-input v-model="data.buyTime"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">终止日期</label>
                  <el-input v-model="data.endTime"
                            disabled></el-input>
                </div>
                <div class="inp additional-information">
                  <label class="label">附加说明</label>
                  <el-input type="textarea"
                            :rows="4"
                            v-model="data.remark"
                            disabled></el-input>
                </div>
              </div>
            </div>
            <div class="item box-primary">
              <div class="staff-top">
                <div class="staff-title">合同</div>
              </div>
              <div class="staff-bottom">
                <div class="inp partner">
                  <label class="label">合作商</label>
                  <el-input v-model="data.cooperativePartner"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">产品状态</label>
                  <el-input v-model="data.productState"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">其他状态</label>
                  <el-input v-model="data.otherState"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">验车状态</label>
                  <el-input v-model="data.checkCarState"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">风险状态</label>
                  <el-input v-model="data.riskState"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">出单人</label>
                  <el-input v-model="data.IssuingPerson"
                            disabled></el-input>
                </div>
                <div class="inp">
                  <label class="label">服务次数</label>
                  <el-input v-model="data.serviceTimes"
                            disabled></el-input>
                </div>
                <div class="inp" v-if="data.productName === '一鉴安心'">
                  <label class="label">鉴定结论</label>
                  <el-input v-model="data.authConclusion"
                            disabled></el-input>
                </div>
              </div>
            </div>
            <div class="item box-primary">
              <div class="staff-top">
                <div class="staff-title">咨询记录</div>
              </div>
              <div class="staff-bottom">
                <el-table :data="consultationRecordData"
                          style="width: 100%">
                  <el-table-column prop="customerName"
                                   label="客户姓名"
                                   width="100"
                                   :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column prop="customerPhone"
                                   label="客户电话"
                                   width="120">
                  </el-table-column>
                  <el-table-column prop="carNo"
                                   label="车牌号"
                                   width="100">
                  </el-table-column>
                  <el-table-column prop="servicePerson"
                                   label="服务人员"
                                   width="100">
                  </el-table-column>
                  <el-table-column prop="time"
                                   label="咨询时间"
                                   width="170">
                  </el-table-column>
                  <el-table-column prop="question"
                                   label="咨询问题"
                                   width="370"
                                   :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column prop="answer"
                                   label="咨询回答"
                                   width="370"
                                   :show-overflow-tooltip="true">
                  </el-table-column>
                </el-table>
                <el-pagination class="page"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="consultationRecordParams.index"
                               :page-sizes="[10,15,20,30,50,100]"
                               :page-size="consultationRecordParams.size"
                               layout="total, prev, pager, next, sizes"
                               :total="consultationRecordTotal"
                               background>
                </el-pagination>
              </div>
            </div>
            <div class="item box-primary">
              <div class="staff-top">
                <div class="staff-title">一号养车</div>
              </div>
              <div class="staff-bottom">
                <el-table :data="carMaintenanceData"
                          style="width: 100%">
                  <el-table-column prop="customerNumber"
                                   label="客户编号"
                                   width="170"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="accountNumber"
                                   label="账号"
                                   width="120"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="registrationTime"
                                   label="注册时间"
                                   width="140"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="failureTime"
                                   label="失效时间"
                                   width="140"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="carOwnerNumber"
                                   label="车主编号"
                                   width="140"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="carNo"
                                   label="车牌号"
                                   width="120"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="affiliation"
                                   label="所属地"
                                   width="220"
                                   align="center"
                                   :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column prop="project"
                                   label="项目"
                                   width="120"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="availableTimes"
                                   label="可用次数"
                                   width="120"
                                   align="center">
                  </el-table-column>
                  <el-table-column prop="lastTimeUsed"
                                   label="最近一次使用时间"
                                   width="170"
                                   align="center">
                  </el-table-column>
                </el-table>
                <el-pagination class="page"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="carMaintenanceParams.index"
                               :page-sizes="[10,15,20,30,50,100]"
                               :page-size="carMaintenanceParams.size"
                               layout="total, prev, pager, next, sizes"
                               :total="carMaintenanceTotal"
                               background>
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="toTop" @click="backTop"></div>
  </div>
</template>

<script>
export default {
  name: 'showInfo',
  data () {
    let arr, callerid, phonePlace
    if (location.search.substring(1)) {
      arr = location.search.substring(1).split('&')
      callerid = Number(arr[0].split('=')[1])
      phonePlace = decodeURIComponent(arr[1].split('=')[1])
    } else {
      callerid = ''
      phonePlace = ''
    }
    return {
      callerid: callerid,
      phonePlace: phonePlace,
      // 员工
      staff: {
        name: '',
        callerid: '',
        departmentName: '',
        postName: ''
      },
      // 车牌号及产品
      selectValue: '',
      options: [],
      data: {
        carTypeBrand: '',
        productTimeLimit: '',
        userPhone: '',
        checkCarState: '',
        buyTime: '',
        remark: '',
        userName: '',
        cooperativePartner: '',
        productState: '',
        productName: '',
        buyCarTime: '',
        carNo: '',
        id: '',
        endTime: '',
        otherState: '',
        shelfLife: '',
        riskState: '',
        IssuingPerson: '',
        serviceTimes: '',
        authConclusion: ''
      },
      // 咨询记录
      consultationRecordTotal: 0,
      consultationRecordParams: {
        index: 1,
        size: 10,
        filters: {
          callerid: callerid
        }
      },
      consultationRecordData: [],
      // 一号养车
      carMaintenanceTotal: 0,
      carMaintenanceParams: {
        index: 1,
        size: 10,
        filters: {
          callerid: callerid
        }
      },
      carMaintenanceData: [],
      scrollTop: 0,
      timer: null
    }
  },
  mounted () {
    this.$refs.target.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    // 关闭页面
    closePage () {
      let userAgent = navigator.userAgent
      if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
        window.location.href = 'about:blank'
      } else {
        window.opener = null
        window.open('', '_self')
        window.close()
      }
    },
    scrollToTop () {
      this.scrollTop = this.$refs.target.scrollTop
    },
    backTop () {
      this.timer = setInterval(() => {
        this.scrollToTopTimer()
      }, 20)
    },
    scrollToTopTimer () {
      let scrollTop = this.scrollTop
      if (scrollTop > 0) {
        scrollTop -= 100
        if (scrollTop <= 0) {
          scrollTop = 0
          clearInterval(this.timer)
        }
      }
      this.$refs.target.scrollTop = scrollTop
    },
    select (id) {
      this.selectValue = id
      this.getContractInfoById()
    },
    // 通过手机号查询员工信息
    getUserInfoByPhone () {
      this.$axios.get(`/huaao-api/report/callInfo/getUserInfoByPhone?callerid=${this.callerid}&phone_place=${this.phonePlace}`).then(res => {
        this.staff = res.data
      })
    },
    // 通过手机号查询车牌号及产品
    getContractListByPhone () {
      return new Promise(resolve => {
        this.$axios.get(`/huaao-api/report/callInfo/getContractListByPhone/${this.callerid}`).then(res => {
          if (res.data.length) {
            this.options = res.data
            this.selectValue = res.data[0].id
            resolve()
          }
        })
      })
    },
    // 通过合同id查询合同详情
    getContractInfoById () {
      this.$axios.get(`/huaao-api/report/callInfo/getContractInfoById/${this.selectValue}`).then(res => {
        this.data = res.data
      })
    },
    // 通过手机号查询咨询记录
    getConsultHisList () {
      let params = this.consultationRecordParams
      this.$axios.post('/huaao-api/report/callInfo/getConsultHisList', params).then(res => {
        if (res.data.items.length > 0) {
          this.consultationRecordData = res.data.items
          this.consultationRecordTotal = Number(res.data.total)
        }
      })
    },
    // 修改表格单页数量
    handleSizeChange (val) {
      this.consultationRecordParams.size = val
      this.getConsultHisList()
    },
    // 翻页
    handleCurrentChange (val) {
      this.consultationRecordParams.index = val
      this.getConsultHisList()
    }
  },
  async created () {
    this.getUserInfoByPhone()
    this.getContractListByPhone().then(res => {
      this.getContractInfoById()
    })
    this.getConsultHisList()
  },
  beforeRouteEnter (to, from, next) {
    document.title = to.meta.title
    next()
  }
}

</script>
<style lang="scss">
.show-info-container {
  width: 100%;
  height: 100%;
  background-color: rgb(225, 225, 225);
  overflow: auto;
  & > .content {
    width: 1080px;
    height: auto;
    margin: 0px auto;
    .box {
      position: relative;
      border-radius: 3px;
      background: #ffffff;
      border-top: 3px solid #d2d6de;
      margin-bottom: 20px;
      width: 100%;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
      border-top-color: #3c8dbc;
      .box-header.with-border {
        border-bottom: 1px solid #f4f4f4;
      }
      .box-header {
        color: #444;
        display: block;
        padding: 10px;
        position: relative;
        .header-left {
          width: 450px;
          height: 30px;
          float: left;
          line-height: 30px;
          padding-left: 10px;
          color: #ffffff;
          .box-title {
            color: black;
            display: inline-block;
            font-size: 14px;
            margin: 0;
            line-height: 1;
          }
        }
        .header-right {
          width: 20px;
          float: right;
          padding-top: 2px;
          text-align: center;
          cursor: pointer;
          .el-icon-close {
            font-weight: bold;
          }
        }
      }
      .box-header:before,
      .box-body:before,
      .box-footer:before,
      .box-header:after,
      .box-body:after,
      .box-footer:after {
        content: " ";
        display: table;
      }
      .box-header:after,
      .box-body:after,
      .box-footer:after {
        clear: both;
      }
      .bg-mg {
        background: #ecf0f5;
        margin-bottom: -30px;
      }
      .box-border-body {
        background: #ecf0f5;
      }
      .box-body {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 3px;
        border-bottom-left-radius: 3px;
        padding: 10px;
        .modal-body {
          position: relative;
          padding: 15px;
          .item.box-primary {
            border-top-color: #3c8dbc;
          }
          .item {
            @extend .box;
            .staff-top {
              @extend .box-header;
              @extend .box-header.with-border;
            }
            .staff-bottom {
              @extend .box-body;
              overflow: hidden;
              .inp {
                margin-bottom: 15px;
                width: 25%;
                float: left;
                padding-right: 15px;
                padding-left: 15px;
                .label {
                  display: inline-block;
                  max-width: 100%;
                  margin-bottom: 5px;
                  font-weight: 700;
                }
              }
              .additional-information {
                width: 100%;
              }
              .partner {
                width: 50%;
              }
              .page {
                margin-top: 10px;
                text-align: right;
              }
            }
            .member-top {
              @extend .staff-top;
            }
            .member-bottom {
              @extend .staff-bottom;
              .inp {
                margin-bottom: 15px;
                width: 50%;
                float: left;
                padding-right: 15px;
                padding-left: 15px;
                .label {
                  display: inline-block;
                  max-width: 100%;
                  margin-bottom: 5px;
                  font-weight: 700;
                }
              }
            }
          }
          .plate-product {
            @extend .box-body;
            .select-plate-product {
              margin-bottom: 15px;
              padding-right: 15px;
              padding-left: 15px;
              .label {
                display: inline-block;
                max-width: 100%;
                margin-bottom: 5px;
                font-weight: 700;
              }
              .select {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  & > .toTop {
    z-index: 10;
    width: 46px;
    height: 46px;
    position: fixed;
    right: 44px;
    top: 500px;
    background-image: url('./assets/goTop.png');
    cursor: pointer;
  }
  .el-input.is-disabled .el-input__inner {
    color: #606266;
  }
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: rgba(0, 0, 0, .1)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/show-info.vue